import React, { Component } from "react";
import { Link } from "react-router";

import { GAME_KEY } from "./gameInfo";
import GrassPage from "./GrassPage";
import { LINK_STYLE, GRASS_BODY } from "./styles";

const ABOUT_BODY_STYLE = {
  fontFamily: "acumin-pro-condensed, san-serif",
  fontSize: 24,
  fontWeight: 300,
  lineHeight: 1.3,
};

class About extends Component {
  render() {
    return (
      <GrassPage>
        <div style={Object.assign({}, GRASS_BODY, { width: 500 })}>
          <div
            style={{
              fontFamily: "acumin-pro-extra-condensed, sans-serif",
              color: "#555",
              fontWeight: 200,
              fontSize: 40,
            }}
          >
            how it works
          </div>
          <br />
          <div style={ABOUT_BODY_STYLE}>
            Squares is a pool game based on a 10x10 grid of (you guessed it) squares! Players buy
            spots on the grid that are then randomly assigned numbers 0-9 along X and Y axes,
            corresponding to the competing teams. If the last digit of the game score matches a
            player’s square at the end of the quarter, half, or game, they win a portion of the pool
            (to be designated by your own house rules).
          </div>
          <br />
          <div style={ABOUT_BODY_STYLE}>
            TL;DR:<br />
            1. Add names<br />
            2. Pick Squares<br />
            3. Profit (maybe)
          </div>
          <br />
          <div>
            <Link to={`/create/${GAME_KEY}`} className="ulh" style={LINK_STYLE}>
              start game
            </Link>
          </div>
        </div>
      </GrassPage>
    );
  }
}
export default About;



// WEBPACK FOOTER //
// ./src/About.js